import { CheckboxWithLabel, type CheckboxWithLabelProps } from "~/common/components/CheckboxWithLabel";
import { Trans, useTranslation } from "react-i18next";
import { LMS_TRAINING_OVERVIEW_URL } from "~/utils/url/staticUrls";
import { useIsMinDesktopSize } from "~/common/hooks/useMediaQuery";
import { Stack, styled, Typography } from "~/common/mui";

const ConsentBox = styled(Stack)(({ theme }) => ({
  padding: theme.spacing(5, 2, 2, 2),
  border: `1px solid ${theme.palette.primary.main}`,
  borderRadius: theme.spacing(0.5),
  position: "relative",
  [theme.breakpoints.up("desktop-s")]: {
    padding: theme.spacing(2),
  },
}));

const FlagBadge = styled("div")(({ theme }) => ({
  ...theme.typography.labelLarge,
  fontWeight: "bold",
  textTransform: "uppercase",
  background: theme.palette.primary.container,
  color: theme.palette.primary.onContainer,
  borderRadius: "0 0 4px 4px",
  position: "absolute",
  top: 0,
  left: theme.spacing(2),
  padding: theme.spacing(0.5, 1),
  [theme.breakpoints.up("desktop-s")]: {
    position: "relative",
    height: "fit-content",
    borderRadius: theme.spacing(0.5),
  },
}));

export { FlagBadge };

export const TrainingConsent = (props: Omit<CheckboxWithLabelProps, "children">) => {
  const { t } = useTranslation();
  const isDesktop = useIsMinDesktopSize();

  return (
    <ConsentBox>
      {!isDesktop && <FlagBadge>{t("myAccount.training.flag.label")}</FlagBadge>}
      <Typography variant="labelLarge" sx={{ mb: 2 }}>
        <Trans i18nKey={"myAccount.training.title"}>
          We are pleased to invite you to our new Schaeffler Training Campus, where you will find all training and
          certification courses offered by the Schaeffler Group worldwide for the Industrial Division. Develop your
          future skills, turn your competence into value and benefit from our expert knowledge and decades of practical
          experience. Tick the box below to enter the details required to access the
          <a href={LMS_TRAINING_OVERVIEW_URL} target="_blank">
            Schaeffler Training Campus.
          </a>
        </Trans>
      </Typography>
      <CheckboxWithLabel {...props}>
        <Trans
          i18nKey={"myAccount.training.terms.label"}
          components={[<span />, <b />, <span />, <a href={window.SCHA.urls.lmsTermsConditions} target="_blank" />]}
        >
          I would like to enter the additional fields and gain access to the
          <b>Schaeffler Training Campus</b>, and by clicking on the "Submit" button below I confirm that I have read and
          accepted the{" "}
          <a href={window.SCHA.urls.lmsTermsConditions} target="_blank">
            Terms of use
          </a>
          .
        </Trans>
      </CheckboxWithLabel>
    </ConsentBox>
  );
};
